/** @format */

import {Route, Routes} from 'react-router-dom';

import {Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import {useFlags} from 'launchdarkly-react-client-sdk';

import {ROUTES} from 'constants/ROUTES';

import {useChatData} from './hooks/useChatData';
import ChatLayout from './components/ChatLayout';
import ChatSidebar from './components/ChatSidebar';
import ChatArea from './components/ChatArea';

const ChatContent = () => {
  const {
    chatId,
    companyId,
    companyName,
    chats,
    messages,
    chatsLoading,
    chatLoading,
    isPending,
    pollTimedOut,
    chatsError,
    chatError,
    sendError,
    handleSelectChat,
    handleNewChat,
    handleSendMessage,
    handleRenameChat,
    handleDeleteChat,
    clearSendError,
  } = useChatData();

  return (
    <ChatLayout
      companyId={companyId}
      companyName={companyName}
      sidebar={
        <ChatSidebar
          chats={chats}
          activeChatId={chatId}
          loading={chatsLoading}
          error={chatsError?.message ?? null}
          onSelectChat={handleSelectChat}
          onNewChat={handleNewChat}
          onRenameChat={handleRenameChat}
          onDeleteChat={handleDeleteChat}
        />
      }
    >
      <ChatArea
        chatId={chatId}
        messages={messages}
        loading={chatLoading}
        error={chatError?.message ?? null}
        sendError={sendError}
        isPending={isPending}
        pollTimedOut={pollTimedOut}
        onSendMessage={handleSendMessage}
        onClearSendError={clearSendError}
      />
    </ChatLayout>
  );
};

const Chat = () => {
  const {isAiAgentChatEnabled} = useFlags();

  if (!isAiAgentChatEnabled) {
    return (
      <Typography variant='h5' sx={{p: 4, textAlign: 'center'}}>
        <Trans>Страница не найдена</Trans>
      </Typography>
    );
  }

  return (
    <Routes>
      <Route index element={<ChatContent />} />
      <Route path={ROUTES.CHATS_SHOW} element={<ChatContent />} />
    </Routes>
  );
};

export default Chat;
